/** @jsx jsx */

import { useState } from 'react';

import { Button } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import GoPublicModal from './GoPublicModal';

const Styles = {
  root: css`
    display: flex;
    justify-content: flex-end;
    margin-top: 25px;
  `,
};

type Props = {
  onConfirmIntention: () => Promise<void>;
};

function GoPublicTrigger({ onConfirmIntention }: Props) {
  const [isModalGoPublicVisible, setIsModalGoPublicVisible] = useState(false);

  return (
    <div css={Styles.root}>
      <Button
        aria-label="Set public intention"
        color="secondary"
        onClick={() => setIsModalGoPublicVisible(true)}
      >
        Take Integration Public
      </Button>
      {isModalGoPublicVisible && (
        <GoPublicModal
          onCancel={() => setIsModalGoPublicVisible(false)}
          onConfirm={() => onConfirmIntention()}
        />
      )}
    </div>
  );
}

export default GoPublicTrigger;
